import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const LightShell: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('settings.shell.lite_shell.enabled.title')}
        description={t('settings.shell.lite_shell.enabled.description')}
        value={settings.lightShell}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.LITE_SHELL,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
      />
    </>
  );
};
